module.exports = __webpack_public_path__ + "static/DPF-Klemmring-3c081eae1097a30790702e1f81493785.jpg";